<template>
    <AppCard>
        <div class="flex items-center">
            <h3 class="text-black text-lg font-bold flex-grow mr-2">{{ model.name }}</h3>

            <AppButton class="flex-shrink-0" :href="viewTyresLink" size="small">
                View tyres
            </AppButton>
        </div>

        <p>{{ toLocaleString(this.model.reviews_count) }} tyre reviews</p>
    </AppCard>

</template>

<script>
import Numbers from "@/Mixins/Utilities/Numbers";
import AppCard from "@/Components/AppCard";
import AppButton from "@/Components/AppButton";

export default {
    components: {AppButton, AppCard},
    mixins: [Numbers],
    props: {
        model: Object,
        manufacturer: Object
    },
    computed: {
        viewTyresLink() {
            const manufacturer = this.manufacturer ?? this.model.manufacturer;

            return this.route("manufacturers.models.show", [
                manufacturer, this.model
            ]);
        }
    }
};
</script>

<style scoped>

</style>
